import image1 from '../../assets/images/slider/slider_img2.jpg';
import image2 from '../../assets/images/slider/slider_img1.jpg';
import image3 from '../../assets/images/slider/slider_img3.jpg';
import image4 from '../../assets/images/slider/slider_img4.jpg';
import image5 from '../../assets/images/slider/slider_img5.jpg';
import image6 from '../../assets/images/slider/slider_img6.jpg';
const content = [
	{
		title: 'Active Learning',
		description:'Abstract: An ideal school embraces the idea that all students can learn, and works tobuild safe learning spaces for students. It attracts teachers who are knowledgeable,who care about student learning, and adapt their instruction to meet the needs of theirlearners. This article will explore the basic characteristic features that make a schoolideal. In order to do that, I will first propose a definition of an ideal school. Then thepaper will discuss the characteristic features that make a school ideal. In conclusion, thepaper will look back at the most salient features of such great schools',
		button: 'Read More',
		image: image1,
		link:'/about',		
	},
	{
		title: 'Funny and Happy',
		description:'Our School is a creative skill and a joy beyond anything found',
		button: 'Read More',
		image: image2,
		link:'/about',		
	},	
	{
		title: 'Fulfill With Love',
		description:'We understand that playing is as important to children as breathing. Little Leader works along the same lines.',
		button: 'Read More',
		image: image3,
		link:'/about',
	},
	{
		title: 'Expert Teachers',
		description:'To educate the little ones is a challenge, but their knowledge is a teacher’s achievement.',
		button: 'Read More',
		image: image4,
		link:'/about',
	},
	{
		title: 'Full Day Programs',
		description:'After-school programs to experience fun in a whole new way!',
		button: 'Read More',
		image: image5,
		link:'/about',
	},
	{
		title: 'Multimedia Class',
		description:'Knowledge and Alertness bring an opportunity to make a difference by multimedia classes.',
		button: 'Read More',
		image: image6,
		link:'/about',
	},
]
export default content;